import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogoFlowr = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 113 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m58.75 3.27 8.06 20.2h1.97l5.15-13.68 5.13 13.68h1.96L89.73.33h-3.09l-5.65 15.36L75.71.33h-5.32l2.16 5.83-3.61 9.92L63 .33h-5.42zM45.59 21.36c4.17 0 6.11-3.46 6.11-9.49s-1.94-9.49-6.11-9.49-6.11 3.46-6.11 9.49 1.94 9.49 6.11 9.49m0-21.36c6.67 0 11.99 5.01 11.99 11.87s-5.32 11.86-11.99 11.86S33.6 18.72 33.6 11.87 38.93 0 45.59 0M97.72 10.97h3.48c3.22 0 5.06-1.25 5.06-4.09 0-2.6-1.77-3.99-5.06-3.99h-3.48v8.07Zm0 12.43h-5.25V.33h10.61c4.73 0 8.7 1.75 8.7 6.23 0 3.89-3.48 5.67-7.19 5.77v.06c2.86.23 4.63 1.45 5.58 4.12l1.09 3c.59 1.55 1.05 2.44 2.13 3.89h-5.91c-.69-1.15-1.11-2.24-1.54-3.43l-1.28-3.63c-.72-2.08-1.64-2.8-3.94-2.8h-2.99v9.85ZM33.09 20.7h-8.27V.33h-5.25V23.4h16.65c-1.28-1.28-1.2-2.7-3.12-2.7M0 .33V23.4h5.25V13.02h8.44v-2.71H5.25V3.03h11.3V.33z",
		style: { fill: "#ff6786" }
	})
});
export default SvgLogoFlowr;
